import { render, staticRenderFns } from "./VenueTerminals.vue?vue&type=template&id=cb48842e&scoped=true&"
import script from "./VenueTerminals.vue?vue&type=script&lang=js&"
export * from "./VenueTerminals.vue?vue&type=script&lang=js&"
import style0 from "./VenueTerminals.vue?vue&type=style&index=0&id=cb48842e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb48842e",
  null
  
)

export default component.exports